import { Component } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { InactivityTimeoutService } from './shared/services/inactivity-timeout.service';
import { InactivityWarningComponent } from './shared/components/inactivity-warning/inactivity-warning.component';
import { GoogleTagManagerService } from './core/services/google-tag-manager.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, InactivityWarningComponent],
   template: `
    <router-outlet></router-outlet>
   <app-inactivity-warning></app-inactivity-warning>
   `,
  
  //imports: [RouterOutlet],
  //template: `<router-outlet></router-outlet>`,
  
  styles: [],
})
export class AppComponent {
  title = 'AMBA Consumer - Engineer Redesign';
 constructor(
    private router: Router,
    private googleTagManager: GoogleTagManagerService,
  ) {
    this.googleTagManager.initialize();

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => {
        this.googleTagManager.trackPageView(event.urlAfterRedirects);
        window.history.pushState(null, '', window.location.href);
        window.scrollTo({
          top: 0,
          left: 0
        });
      });

    window.addEventListener('popstate', this.preventBrowserBack);
  }

  private preventBrowserBack = (): void => {
    window.history.forward();
  };
}